<template lang="pug">
#modal-selecionar-territorios-ar
    el-dialog.modal-selecionar-territorios-ar-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='960px'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.relatorioRastreabilidade.cadastro.selecioneTerritorioDesejaAdicionarAr') }}

        .el-collapse-item__container
            el-table(
                :key="listagemTableKey('territorios-modal-ar', dadosPaginado, paginaAtual)",
                ref='tabelaModalSelecionarTerritoriosRef',
                :data='dadosPaginado',
                style='width: 100%'
            )
                el-table-column(width='50')
                    template(slot-scope='scope')
                        el-radio(v-model='dadoSelecionado', :label='scope.row') &nbsp

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.territorio")',
                    min-width='200'
                )
                    template(slot-scope='scope') {{ scope.row.nome }}

                el-table-column(label='RENSPA', min-width='150')
                    template(slot-scope='scope') {{ formatarRenspa(scope.row.renspa) }}

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.codigoLyra")',
                    min-width='130'
                )
                    template(slot-scope='scope') {{ scope.row.codigoLyra || '-' }}

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.listagem.localidade")',
                    min-width='150'
                )
                    template(slot-scope='scope') {{ scope.row.localidade }}

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.listagem.departamentoProvincia")',
                    min-width='250'
                )
                    template(slot-scope='scope') {{ scope.row.departamento }} / {{ scope.row.provincia }}

        .c-pagination
            el-pagination(
                background,
                :page-size='pageCount',
                :pager-count='pageCount',
                :current-page.sync='paginaAtual',
                layout='prev, pager, next',
                :total='dados.length',
                @current-change='mudarPagina'
            )

        footer.my-3(slot='footer')
            el-button(@click='fecharModal')
                | {{ $t('mensagens.comuns.voltar') }}
            div(v-if='!dadoSelecionado')
                el-tooltip(
                    effect='dark',
                    :content='$t("mensagens.relatorioRastreabilidade.cadastro.selecioneUmCarAntesDeConfirmar")',
                    placement='top'
                )
                    el-button(
                        type='primary',
                        @click='retornarDadosSelecionado'
                    )
                        | {{ $t('mensagens.comuns.confirmar') }}
            div(v-else)
                el-button(type='primary', @click='retornarDadosSelecionado')
                    | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
export default {
    name: 'ModalSelecionarTerritoriospPY',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        },
        tipoContrato: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            dadoSelecionado: null,
            paginaAtual: 1,
            pageCount: 5
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.dadoSelecionado = null;
        }
    },

    computed: {
        dadosPaginado() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.dados.slice(inicio, fim);
        }
    },

    methods: {
        retornarDadosSelecionado() {
            if (!this.dadoSelecionado) {
                return;
            }

            const emailRepresentante = this.dadoSelecionado.emailRepresentante;
            const contratosBloqueantes = ['SOJA_2BSVS_AR', 'SOJA_EUDR_AR'];
            
            if (contratosBloqueantes.includes(this.tipoContrato)) {
                if (!emailRepresentante || emailRepresentante.toString().trim() === '') {
                    this.$message.warning(
                        this.$t('mensagens.relatorioRastreabilidade.cadastro.emailNaoPodeSerVazio')
                    );
                    return;
                }
            }

            this.$emit('retornarDadosSelecionados', this.dadoSelecionado, this.tipoContrato);
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },

        formatarRenspa(renspa) {
            if (!renspa) return '-';
            if (renspa.length !== 13) return renspa;
            return `${renspa.slice(0, 2)}.${renspa.slice(2, 5)}.${renspa.slice(
                5,
                6
            )}.${renspa.slice(6, 11)}/${renspa.slice(11)}`;
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.alertaDadosNaoSeraoSalvos'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.dadoSelecionado = null;
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        }
    }
};
</script>

<style lang="scss">
#modal-selecionar-territorios-ar {
    footer {
        display: flex;
        justify-content: space-between;
    }
    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }
    label {
        margin: 0 !important;
    }

    .informar-car-manualmente-car {
        display: flex;
        margin-top: 24px;
        gap: 5px;
        align-items: center;
        flex-wrap: wrap;
        background-color: #e7e7e7;
        border-radius: 5px;
        padding: 8px 8px;
        min-height: 6px;
    }
}
.modal-selecionar-territorios-ar-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }
}
</style>
